import React from 'react';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useEventChatSessions} from '../../../../../../data/hooks/chat/useEventChatSessions';

function StepViewChats(props) {
    const {eventId} = props,
        i18n = useI18n(),
        chats = useEventChatSessions(eventId);

    return (
        <StartNetworkingStep href={['/events', eventId, 'chats'].join('/')} complete={chats.length > 0} disabledHint={i18n['start.view_chats.disabled']}>
            {i18n['start.view_chats']}
        </StartNetworkingStep>
    );
}

export default StepViewChats;
